import { z } from 'zod';

import { chatEventIdSchema, chatMessageIdSchema, chatThreadIdSchema } from './chat-ids';

export const awaitingCallbackSchema = z.object({
    blockId: z.uuid(),
    eventId: chatEventIdSchema,
});

export type AwaitingCallback = z.infer<typeof awaitingCallbackSchema>;

export const pendingTurnSchema = z.object({
    awaitingCallback: awaitingCallbackSchema.nullable().optional(),
    messageId: chatMessageIdSchema,
    since: z.string(),
});

export type PendingTurn = z.infer<typeof pendingTurnSchema>;

export const threadSchema = z.object({
    createdAt: z.string(),
    id: chatThreadIdSchema,
    name: z.string().nullable().optional(),
    pendingTurn: pendingTurnSchema.nullable().optional(),
    updatedAt: z.string(),
});

export type Thread = z.infer<typeof threadSchema>;

export const threadListSchema = z.object({
    threads: z.array(threadSchema),
});

export type ThreadList = z.infer<typeof threadListSchema>;

export const createThreadRequestSchema = z.object({}).strict();

export type CreateThreadRequest = z.infer<typeof createThreadRequestSchema>;
